module.exports = __webpack_public_path__ + "media/splash/launch-750x1334-200279f0.png";